/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { AppError } from './AppError';

export class SamlNotAllowedError extends AppError {
    public TAG: string = 'SamlNotAllowedError';

    protected title: string = 'SamlNotAllowedError';

    protected description: string;

    protected type: string = 'SamlNotAllowedError';

    public constructor(code: string) {
        super(code, 'SamlTokenRequestNotAllowed, application reset / reinstalled');
        this.description = 'no license plate code found, user not allowed to request a SAML token';
        this.title = 'SamlNotAllowedError';
    }

    public getDescription(): string {
        return this.description;
    }

    public getTitle(): string {
        return this.title;
    }

    public getType(): string {
        return this.type;
    }
}
